export enum CustomerApiTags {
  customer = "Customer",
  tableCustomer = "TableCustomer",
}
